import { graphql } from "~/gql";

export const CREATE_BRAND = graphql(/* GraphQL */ `
  mutation createBrand($data: BrandInput!) {
    createBrand(data: $data) {
      ...BrandParts
    }
  }
`);
